import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Media, Form } from 'react-bootstrap';
import notifier from '../../../../_utils/notifier';
import { getUserData, updateUserData } from '../../../actions/user';

import { ThreeDots } from '../../common/Placeholders.jsx';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { Page } from '../../../hoc/Page.jsx';
import TinyContentInfoBlock from '../../common/TinyContentInfoBlock.jsx';
import UserPhotoEditor from '../../common/UserPhotoEditor.jsx';
import ProfileFormFirst from './ProfileFormFirst.jsx';
import ProfileFormSecond from './ProfileFormSecond.jsx';
import ProfileModal from './ProfileModal.jsx';

import normalizePhone from './normalizePhone';
import StorageAPI from '../../../../_utils/localStorage';
import { getLangList } from '../../../actions/lang';
import { getSystemsList } from '../../../actions/shop';



const Profile = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [langList, setLangList] = useState([]);
  const [paymentSystems, setPaymentSystems] = useState([]);
  const [localStorageData, setLocalStorageData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [firstFormInitialValues, setFirstFormInitialValues] = useState(null);
  const [secondFormInitialValues, setSecondFormInitialValues] = useState(null);

  const storageWorker = new StorageAPI('profile');

  useEffect(() => {
    props.getLangList().then(response => setLangList(response));
    props.getSystemsList().then(response => setPaymentSystems(response));
    props.getUserData(props.userSlug).then((response) => {
      let values = response;
      for (const [key, value] of Object.entries(response)) {
        if (key === 'phone_number'){
          values[key] = normalizePhone(value)
        }
      }
      setUserData(values);
      setIsLoading(false);
    });

    setLocalStorageData(storageWorker.getData());
  }, []);

  useEffect(() => {
    if (userData){
      setFirstFormInitialValues(getUserDataByKeys(['first_name', 'last_name', 'birthday', 'sex']));
      setSecondFormInitialValues(getUserDataByKeys(['phone_number', 'living_place', 'about', 'lang', 'payment_service', 'slug']));
    }
  }, [userData]);

  function getUserDataByKeys(keys){
    let values = {};
    for (const [key, value] of Object.entries(userData)) {
      if (keys.includes(key)){
        values[key] = value;
      }
    }
    return values;
  }

  const setLocalStorage = (e) => {
    let value = e.target.value.trim();
    if (value) storageWorker.addData({[e.target.name]: value});
  }
  const clearLocalStorage = () => storageWorker.removeData();
  const loadFromLocalStorage = () => setUserData({...userData, ...localStorageData},);

  const handleSubmit = async (formData) => {
    const response = await props.updateUserData(formData);
    if (response === undefined){
      notifier.success(gettext('Данные успешно сохранены'));
      storageWorker.removeData();
    }
  }

  if (isLoading) return <ThreeDots/>;
  return(<div>
    <TinyContentInfoBlock name='users_profile_info' />
    <Media className='flex-wrap'>
      <UserPhotoEditor photo={ props.photo } sex={ props.sex }/>
      <Media.Body className='flex-wrap'>
        <Form.Group controlId='email_id' className='flex-grow-1'>
          <Form.Label>{ gettext('Адрес электронной почты.') } *</Form.Label>
          <Form.Control as='input' disabled={ true } name='email' value={ props.email }/>
        </Form.Group>

        <ProfileFormFirst initialValues={ firstFormInitialValues }
                          onSubmit={ handleSubmit }
                          setLocalStorage={ setLocalStorage } />

        <p><hr/></p>

        <ProfileFormSecond initialValues={ secondFormInitialValues }
                           onSubmit={ handleSubmit }
                           setLocalStorage={ setLocalStorage }
                           langList={ langList }
                           paymentSystems={ paymentSystems } />

      </Media.Body>
    </Media>
    { localStorageData && <ProfileModal data={ localStorageData }
                                        show={ true }
                                        langList={ langList }
                                        paymentSystems={ paymentSystems }
                                        clearData={ clearLocalStorage }
                                        loadData={ loadFromLocalStorage } /> }
  </div>);
}

Profile.PropTypes = {
  userSlug: PropTypes.string.isRequired,
  photo: PropTypes.string,
  email: PropTypes.string,
  sex: PropTypes.string,

  getUserData: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
  getLangList: PropTypes.func.isRequired,
  getSystemsList: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    userSlug: state.auth.slug,
    photo: state.user.photo,
    email: state.user.email,
    sex: state.user.sex,
  }
};

export default compose(
  connect(mapStateToProps, { getUserData, updateUserData, getLangList, getSystemsList }),
  LoginRequired,
  Page
)(Profile);

